module.exports = __webpack_public_path__ + "static/media/teu-card-cards.375be5a4.png";